import { Component, OnInit } from '@angular/core';
import { ModalService, ModalcloseReason } from 'hsg';
import { AuthBaseComponent } from '../auth-base/auth-base.component';
import { Message } from '../models/message.model';
import { ServerResponse } from 'src/app/authentication/constants/server-response.model';

@Component({
  selector: 'app-auth-end-process',
  templateUrl: './auth-end-process.component.html',
  styleUrls: ['./auth-end-process.component.css']
})
export class AuthEndProcessComponent extends AuthBaseComponent implements OnInit {

  data: Message | any;
  ngOnInit() {
    this.data = this.modalService.data;
    //this will report 2174 elastic code
    if (this.data.elasticCode) {
      this.authUserService.sendAuthData("ElasticLogger", { elasticCode: this.data.elasticCode })
        .subscribe(res => console.log("sent elasticLog code:2174 - open window", res), error => console.log("sent elasticLog - open window error!", error));
      sessionStorage.setItem("elasticCode", "");
      this.isShowContactLink = this.shouldContactLink('authEndProcess');
    }
    if (this.data.ProcessError == ServerResponse.ALREADY_EXIST) {
      this.authUserService.sendAuthData("ElasticLogger", { elasticCode: '2176' })
        .subscribe(res => console.log("sent elasticLog code:2176 - open window", res), error => console.log("sent elasticLog - open window error!", error));
    }
    if (this.data.id == "CUSTOMER_SERVICE")
      this.data.gaLabel = 'User Initiated = ' + (this.data.CustomerServiceReason == 23) + ' - ' + this.data.CustomerServiceReason + ' - ' + this.data.MsgCustomerServiceReason;
    if (this.data.id = "TECHNICAL_ERROR")
      this.data.gaLabel = 'Screen Name = ' + sessionStorage.getItem("currentWindow");
    //sessionStorage.clear();
  }
  finish() {
    this.modalService.close(this.data, ModalcloseReason.buttonX);
  }
}
